export default __webpack_public_path__ + "static/media/lysningen-property-09.85539c87.jpg";